import type { ReactNode } from 'react'
import { noop } from 'lodash-es'
import styles from './WorkspaceSearchView.module.css'
import { Form } from '@/components/Form'
import { ButtonCollection } from '@/components/ButtonCollection'
import { Button } from '@/components/Button'

export interface WorkspaceSearchViewProps {
  canContinue: boolean
  onContinue: () => unknown
  children: ReactNode
}

export function WorkspaceSearchView({
  canContinue,
  onContinue,
  children,
}: WorkspaceSearchViewProps) {
  return (
    <div className={styles.root}>
      {/* Pressing Enter in the search field must not submit the page. */}
      <Form className={styles.inputGroup} onSubmit={noop}>
        {children}
        <ButtonCollection>
          <Button
            label="Continue"
            variant="primary"
            isDisabled={!canContinue}
            onPress={() => onContinue()}
          />
        </ButtonCollection>
      </Form>
    </div>
  )
}
